module.exports = __webpack_public_path__ + "e59f90ee2f420e93a8a290558a423c6b.svg";